import { useGameStore } from "@/store/gameStore";
import { requiredDiscardCount } from "@/engine/LegalActions";

// 弃牌阶段提示 banner：显示已选/需要 + 一键弃置最低价值的便捷提示
// 主要选择逻辑在 Hand.tsx 中通过 toggleDiscardUid 实现；ActionBar 已有"确认弃牌"按钮
export default function DiscardPicker() {
  const state = useGameStore((s) => s.state);
  const humanId = useGameStore((s) => s.humanPlayerId);
  const pendingDiscardUids = useGameStore((s) => s.pendingDiscardUids);
  const clearDiscardUids = useGameStore((s) => s.clearDiscardUids);

  if (!state) return null;
  if (state.phase !== "discard") return null;
  const cur = state.players[state.currentPlayerIdx];
  if (cur.id !== humanId) return null;

  const need = requiredDiscardCount(cur);
  // 仅统计手牌中真实存在的已选 uid（防御跨阶段残留的旧 uid）
  const have = pendingDiscardUids.filter((uid) =>
    cur.hand.some((c) => c.uid === uid)
  ).length;
  if (need <= 0) return null;

  return (
    <div className="discard-picker" role="status">
      <span className="discard-picker__hint">
        弃牌阶段：已选 {have}/{need} 张（点击手牌切换选择）
      </span>
      {have > 0 && (
        <button
          className="discard-picker__clear"
          onClick={clearDiscardUids}
        >
          清空
        </button>
      )}
    </div>
  );
}
